module.exports = __webpack_public_path__ + "img/mmdc-h.93410a50.png";